import React, { CSSProperties, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
  color: CSSProperties['fill'];
}

/* eslint-disable max-len */
const Hourglass: React.FunctionComponent<IProps> = ({ color, ...props }: IProps) => (
  <svg viewBox="0 0 1449 1935" {...props}>
    <g fill={color} fillRule="nonzero">
      <rect x={2} width={1447} height={245} rx={92} />
      <rect y={1690} width={1449} height={245} rx={92} />
      <path d="M724 1004c231.82 0 447-153.64 557.57-392.94C1338.01 488.91 1358 339.49 1358 187c0-15.92-.35-31.74-1.05-47.44-9.72-218.8-358.41-67.66-676.62-61.73-305.9 5.7-581.82-142.31-589.61 69.91-.48 13.01-.72 26.1-.72 39.26 0 156.33 25.5 299.9 84.6 424.06C286.08 845.26 495.16 1004 724 1004z" />
      <path d="M724 934.47c231.82 0 447 153.64 557.57 392.94 56.44 122.16 76.43 271.58 76.43 424.06 0 15.93-.35 31.74-1.05 47.44-9.72 218.8-358.41 67.66-676.62 61.73-305.9-5.7-581.82 142.31-589.61-69.9-.48-13.02-.72-26.1-.72-39.27 0-156.32 25.5-299.9 84.6-424.06 111.48-234.2 320.56-392.94 549.4-392.94z" />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default Hourglass;
